import { render, staticRenderFns } from "./AgentRanking.vue?vue&type=template&id=30481e55&"
import script from "./AgentRanking.vue?vue&type=script&lang=js&"
export * from "./AgentRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports